import {jsx} from 'panel';

import {Segmentation} from 'common/types/reports/query';
import {BucketPaneEl} from 'common/widgets/bucket-pane';
import {SelectTheme} from 'common/components/select/constants';
import {SelectEl} from 'common/components/select';
import {ButtonSize} from 'common/components/button/constants';

import {CUSTOM_BUCKET_NAMING} from '../constants';
import {EntryPart, isSegmentEntry} from '../types';
import type {QueryEntrySection} from '../index';

function CustomBucket({el, index}: {el: QueryEntrySection; index: number}) {
  const entry = el.getEntries()[index];
  const bucketProps =
    el.usingNewBucketing(index) && isSegmentEntry(entry) ? {segment: entry.event as Segmentation} : {};
  return (
    <BucketPaneEl
      attrs={el.helpers.getCustomBucketPaneAttributes()}
      props={bucketProps}
      on={{
        close: () => el.setActiveEntry(null, null),
        updateSegment: el.helpers.onUpdateBucketProperty,
        changeSelectedBucket: el.helpers.onChangeSelectedCustomBucket,
        resetBucket: el.helpers.onResetCustomBucket,
      }}
    />
  );
}

export function CustomBucketSubitem({section, index}: {section: QueryEntrySection; index: number}) {
  if (!section.hasNewQBUI()) {
    return null;
  }

  const {index: activeIndex, part: activePart} = section.state.openEntry;
  const isOpen = activeIndex === index && activePart === EntryPart.CustomBucketing;
  const bucketLabel = section.getCustomBucketText(index, isOpen);
  return (
    <>
      {(bucketLabel || isOpen) && (
        <div sel='.subitem-text'>
          <SelectEl
            sel='.subitem-select'
            attrs={{
              label: bucketLabel || CUSTOM_BUCKET_NAMING.entrypointName,
              open: isOpen,
              theme: SelectTheme.QbSubitem,
              size: ButtonSize.Small,
              'prevent-close': true,
            }}
            on={{
              menuChange: (ev) => section.helpers.onCustomizeBucketsMenuChange(ev, index),
            }}
          >
            <div attrs={{slot: `body`}}>{isOpen && <CustomBucket el={section} index={index} />}</div>
          </SelectEl>
        </div>
      )}
    </>
  );
}
